import React, { CSSProperties } from "react";
import classNames from "./Loader.module.css";

type LoaderProps = {
  size?: number;
  inline?: boolean;
  style?: CSSProperties;
};

const Loader = (props: LoaderProps) => {
  if (!props.inline) {
    return (
      <div
        className={classNames.Loader}
        style={
          props.size
            ? ({
                "--size": `${props.size}px`,
                ...props.style,
              } as React.CSSProperties)
            : props.style
        }
      >
        <div className={classNames.LoaderDot} />
        <div className={classNames.LoaderDot} />
        <div className={classNames.LoaderDot} />
        <div className={classNames.LoaderDot} />
      </div>
    );
  }

  return (
    <div
      className={classNames.InlineLoader}
      style={
        props.size
          ? ({
              "--size": `${props.size}px`,
              ...props.style,
            } as React.CSSProperties)
          : props.style
      }
    >
      <div className={classNames.LoaderDot} />
      <div className={classNames.LoaderDot} />
      <div className={classNames.LoaderDot} />
      <div className={classNames.LoaderDot} />
    </div>
  );
};

export default Loader;
